import { createActionGroup, props } from "@ngrx/store";

export const ThemeActions = createActionGroup({
  source: 'Navbar Theme',
  events: {
    'Toggle Theme': props<({ theme: 'light' | 'dark' })>()
  }
})